import { MY_SUBSCRIPTIONS_RECEIVE } from "../constants";

export const myAccountMySubscriptions = (state = { }, action) => {
    switch (action.type) {
        case MY_SUBSCRIPTIONS_RECEIVE:
            return {
                ...state,
                payload: action.payload,
            };
        default:
            return state;
    }
};
